import React, { useEffect, useState } from 'react';

const EditableCardContent = ({ card, onSave, onCancel }) => {
    const [question, setQuestion] = useState(card.question);
    const [answer, setAnswer] = useState(
        typeof card.answer === 'string' ? card.answer : JSON.stringify(card.answer, null, 2)
    );

    useEffect(() => {
        setQuestion(card.question);
        setAnswer(typeof card.answer === 'string' ? card.answer : JSON.stringify(card.answer, null, 2));
    }, [card]);

    const handleSave = () => {
        let parsedAnswer = answer;
        try {
            if ((answer.startsWith('[') && answer.endsWith(']')) || (answer.startsWith('{') && answer.endsWith('}'))) {
                parsedAnswer = JSON.parse(answer);
            }
        } catch (e) {
            console.warn('Could not parse edited answer as JSON, saving as string.', e);
        }
        onSave({ ...card, question, answer: parsedAnswer });
    };

    return (
        <div className="edit-mode">
            <textarea className="edit-textarea" value={question} onChange={(e) => setQuestion(e.target.value)} />
            <textarea className="edit-textarea" value={answer} onChange={(e) => setAnswer(e.target.value)} />
            <div className="edit-actions">
                <button onClick={handleSave} className="edit-save-btn">Save</button>
                <button onClick={onCancel} className="edit-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default EditableCardContent;


